import { usePreferences, useCompanyPreferences } from "./usePreferences";

export const useFiltersConfig = (feature: string) => {
    const companyFilters = useCompanyPreferences(`${feature}.filters`);
    const filters = usePreferences(`${feature}.filters`);
    return companyFilters?.length > 0 ? companyFilters : filters;
};
